import './index.css'
import React, { useState } from 'react'
import isEmailStringUtil from 'utils/string/is-email'
import { submitReviewUtil } from 'containers/QuickShopProductSidebar/components/Reviews/components/WriteReview/utils/submit-review/index.js'
import ReviewSubmitted from 'containers/QuickShopProductSidebar/components/Reviews/components/WriteReview/components/Submitted/index.js'
import RatingStars from 'containers/QuickShopProductSidebar/components/Reviews/components/WriteReview/components/RatingStars/index.js'
import ReviewForm from 'containers/QuickShopProductSidebar/components/Reviews/components/WriteReview/components/Form/index.js'
import ReviewTerms from 'containers/QuickShopProductSidebar/components/Reviews/components/WriteReview/components/Terms/index.js'
import ReviewButtons from 'containers/QuickShopProductSidebar/components/Reviews/components/WriteReview/components/Buttons/index.js'

const WRITE_REVIEW_TEXT = 'Write a review'

const WriteReview = ({ onClose, productId, isReviewSubmitted, setIsReviewSubmitted }) => {
  const [rating, setRating] = useState(0)
  const [hover, setHover] = useState(0)
  const [formData, setFormData] = useState({
    review_title: '',
    review_body: '',
    reviewer_name: '',
    reviewer_email: ''
  })

  const [loading, setLoading] = useState(false)
  const [isEmailValid, setIsEmailValid] = useState(true)

  const isFormValid = () => {
    return (
      rating > 0 &&
      formData.review_title.trim() !== '' &&
      formData.review_body.trim() !== '' &&
      formData.reviewer_name.trim() !== '' &&
      formData.reviewer_email.trim() !== '' &&
      isEmailValid
    )
  }

  const handleInputChange = (e) => {
    const { name, value } = e.target
    setFormData(prev => ({
      ...prev,
      [name]: value
    }))

    if (name === 'reviewer_email') {
      setIsEmailValid(isEmailStringUtil(value))
    }
  }

  const resetForm = () => {
    setFormData({
      review_title: '',
      review_body: '',
      reviewer_name: '',
      reviewer_email: ''
    })
    setRating(0)
    setHover(0)
    setIsEmailValid(true)
  }

  const handleSubmitReview = async (event) => {
    event.preventDefault()
    setLoading(true)

    try {
      await submitReviewUtil({
        reviewerName: formData.reviewer_name,
        reviewerEmail: formData.reviewer_email,
        rating,
        title: formData.review_title,
        body: formData.review_body,
        productId
      })

      setLoading(false)
      setIsReviewSubmitted(true)
      resetForm()
    } catch (error) {
      setLoading(false)
      console.error('Error submitting review:', error)
    }
  }

  if (isReviewSubmitted) {
    return (
      <ReviewSubmitted onClose={onClose} />
    )
  }

  return (
    <div className='write-review-container'>
      <div className='jdgm-form-wrapper'>
        <form className='jdgm-form' noValidate>
          <div className='review-title'>{WRITE_REVIEW_TEXT}</div>

          <RatingStars
            rating={rating}
            setRating={setRating}
            hover={hover}
            setHover={setHover}
          />

          <ReviewForm
            formData={formData}
            handleInputChange={handleInputChange}
            isEmailValid={isEmailValid}
          />

          <ReviewTerms />

          <ReviewButtons
            onClose={onClose}
            handleSubmitReview={handleSubmitReview}
            isFormValid={isFormValid}
            loading={loading}
          />
        </form>
      </div>
    </div>
  )
}

export default WriteReview
